import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function PipelineStagesCard({ filter, setFilter }) {
  const options = ["Today", "This Week", "This Month", "This Year"];

  return (
    <Card className="pipeline-card">
      {/* HEADER */}
      <Card.Header className="pipeline-header">
        <h5>Pipeline Stages</h5>

        <Dropdown>
          <Dropdown.Toggle className="filter-btn text-dark">
            <FiCalendar className="me-1" />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" className="dropdown-menu-custom">
            {options.map((item) => (
              <Dropdown.Item
                key={item}
                onClick={() => setFilter(item)}
                className={filter === item ? "active-item" : ""}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      {/* BODY */}
      <Card.Body>
        {/* FUNNEL */}
        <div className="funnel">
          <div className="bar bar1">Marketing : 7,898</div>
          <div className="bar bar2">Sales : 4,658</div>
          <div className="bar bar3">Email : 2,898</div>
          <div className="bar bar4">Chat : 789</div>
          <div className="bar bar5">Operational : 655</div>
          <div className="bar bar6">Calls : 454</div>
        </div>

        {/* VALUES */}
        <h6 className="section-title">Leads Values By Stages</h6>

        <div className="value-boxes">
          {[
            { name: "Marketing", value: "$5,221,45" },
            { name: "Sales", value: "$30,424" },
            { name: "Email", value: "$21,135" },
            { name: "Chat", value: "$15,235" },
            { name: "Operational", value: "$10,557" },
          ].map((item) => (
            <div className="value-card" key={item.name}>
              <div className="value-title">
                <span className="dot"></span>
                {item.name}
              </div>
              <div className="value-amount">{item.value}</div>
            </div>
          ))}
        </div>
      </Card.Body>

      {/* CSS */}
      <style>{`
        .pipeline-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

        .pipeline-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #fff;
          border-bottom: 1px solid #eee;
          padding: 16px;
        }

        .pipeline-header h5 {
          margin: 0;
          font-weight: 600;
          font-size: 16px;
        }

        /* FILTER BUTTON */
        .filter-btn {
          background: #f3f4f6 !important;
          border: 1px solid #e5e7eb !important;
          border-radius: 8px !important;
          font-size: 14px;
          padding: 6px 12px !important;
          display: flex;
          align-items: center;
        }

        .filter-btn:hover {
          background: #ffe7d6 !important;
          color: #f97316 !important;
          border-color: #f97316 !important;
        }

        /* DROPDOWN */
        .dropdown-menu-custom {
          border-radius: 10px;
          padding: 6px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.08);
        }

        .dropdown-menu-custom .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
        }

        .dropdown-menu-custom .dropdown-item:hover {
          background: #fff3ed;
          color: #f97316;
        }

        .active-item {
          background: #f97316 !important;
          color: #fff !important;
        }

        /* FUNNEL */
        .funnel {
          margin-top: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0px;
        }

        .bar {
          text-align: center;
          padding: 12px;
          border-radius: 10px;
          color: #fff;
          font-size: 14px;
          font-weight: 500;
        }

        .bar1 { width: 85%; background: #f97316; }
        .bar2 { width: 75%; background: #f9803a; }
        .bar3 { width: 65%; background: #fb9960; }
        .bar4 { width: 55%; background: #fcb07f; }
        .bar5 { width: 45%; background: #fdc79f; }
        .bar6 { width: 35%; background: #fddbc0; color:#333; }

        /* SECTION TITLE */
        .section-title {
          margin-top: 20px;
          margin-bottom: 15px;
          font-weight: 600;
          font-size: 15px;
        }

        /* VALUE BOXES */
      .value-boxes {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 5 equal boxes */
  gap: 12px;
}

.value-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 12px;
  border-radius: 10px;
}

        .value-title {
          font-size: 14px;
          color: #6b7280;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .value-amount {
          font-size: 15px;
          font-weight: 600;
          margin-top: 5px;
        }

        .dot {
          width: 6px;
          height: 6px;
          background: #f97316;
          border-radius: 50%;
        }

        /* RESPONSIVE */
      @media (max-width: 1024px) {
  .value-boxes {
    display: flex;
    overflow-x: auto;
  }

  .value-card {
    min-width: 150px;
  }
}
      `}</style>
    </Card>
  );
}